// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function Icon({className, iconName, fontType, spin, style, title}) {
    const getClass = () =>
        classnames(
            {
                fa: fontType === 'fa',
                mc: fontType === 'mc',
                icon: fontType === 'fa',
                'fa-spin': fontType === 'fa' && spin,
                [`${fontType}-${iconName}`]: fontType,
            },
            className
        );

    return <i aria-hidden={true} className={getClass()} style={style} title={title} />;
}

Icon.propTypes = {
    className: PropTypes.string,
    fontType: PropTypes.string,
    iconName: PropTypes.string,
    spin: PropTypes.bool,
    style: PropTypes.object,
    title: PropTypes.string,
};

export default Icon;
